import React from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import LoginForm from './LoginForm'
import RegisterForm from './RegisterForm'

class ModalWrap extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			defaultAuth: true
		}
		this.switchAuth = this.switchAuth.bind(this)
	}
	
	switchAuth() {
		this.setState({
			defaultAuth: !this.state.defaultAuth
		})
	}
	
	componentWillMount() {
		if (!this.props.defaultAuth) {
			this.switchAuth()
		}
	}
	
	render() {
		const { onClose } = this.props
		return (
			<div className="modal-wrap">
				{this.state.defaultAuth ? (
					<LoginForm switchAuth={ this.switchAuth } onClose={ onClose } />
				):(
					<RegisterForm switchAuth={ this.switchAuth } onClose={ onClose } />
				)}
			</div>
		)
	}
}

class ModalClose extends React.Component {
	render() {
		const { onClose } = this.props
		return (
			<a className="modal-close" onClick={onClose} >
				<span>
					<svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M6 4.586l4.24-4.24c.395-.395 1.026-.392 1.416-.002.393.393.39 1.024 0 1.415L7.413 6l4.24 4.24c.395.395.392 1.026.002 1.416-.393.393-1.024.39-1.415 0L6 7.413l-4.24 4.24c-.395.395-1.026.392-1.416.002-.393-.393-.39-1.024 0-1.415L4.587 6 .347 1.76C-.05 1.364-.048.733.342.343c.393-.393 1.024-.39 1.415 0L6 4.587z"></path></svg>
				</span>
			</a>
		)
	}
}

class AuthModal extends React.Component {
	render() {
		
		const { onOverlay, onClose, isOpen, transitionName, item, defaultAuth } = this.props
		
	    if(isOpen){
			return (
				<TransitionGroup>
					<CSSTransition
					 classNames={transitionName}
					 timeout={{ enter: 200, exit: 200 }}
					>
						<div data-modal="true" onClick={ onOverlay } className="module-modal" >
							<ModalClose onClose={ onClose } />
							<div data-modal="true" className="modal-wrapper">
								<div className="modal-inner">
									<ModalWrap defaultAuth={ defaultAuth } onClose={ onClose } />
								</div>
							</div>
						</div>	
					</CSSTransition>
				</TransitionGroup>
			);
		} else {
	        return <TransitionGroup classnames={transitionName} />;
	    }
	    
	}
}

export default AuthModal


// WEBPACK FOOTER //
// ./src/components/Modals/AuthModal.js